import { render } from "./matching-results-loading.vue?vue&type=template&id=d9e24afc&ts=true"
import script from "./matching-results-loading.vue?vue&type=script&lang=ts"
export * from "./matching-results-loading.vue?vue&type=script&lang=ts"

import "./matching-results-loading.vue?vue&type=style&index=0&id=d9e24afc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__